document.addEventListener("DOMContentLoaded", function () {
    // Handle close button click
    document.addEventListener("click", function (e) {
        if (e.target.closest(".menu-drawer-close")) {
            const details = e.target.closest("details");
            if (details) {
                const summary = details.querySelector("summary");
                if (summary) summary.click();
            }
        }
    });

    initHeadingSplit();
    initVideoPlayButton();
    initRecentlyViewedProducts();
    initCollectionFilterTrigger();
});

window.addEventListener("load", function(){
    setTimeout(() => {
        initCustomSpecialProgressBar();
        addCouponDivInCart();
        observeCartDrawerUpdates();
    }, 500);
});

function initHeadingSplit() {
    if (document.body.classList.contains("template-blog")) {
        splitHeadingIntoSpans(".main-blog > .title--primary");
    }
}

function splitHeadingIntoSpans(selector) {
    const el = document.querySelector(selector);
    if (!el) return;

    const words = el.textContent.trim().split(/\s+/);
    if (words.length <= 1) return;

    const firstWord = words.shift();
    const wrappedWords = words.map(word => `<span>${word}</span>`).join("");

    el.innerHTML = firstWord + " " + wrappedWords;
}

function initVideoPlayButton() {
    document.addEventListener("click", function(e){
        const target = e.target.closest(".play_button");
        if(!target) return;

        const video = target.closest(".video_wrapper")?.querySelector("video");
        if(!video) return;

        if (video.paused || video.ended) {
            video.play();
            target.classList.add("disabled");
        } else {
            video.pause();
            target.classList.remove("disabled");
        }
    });
}

function initRecentlyViewedProducts() {
    const recentProductsKey = "recently_viewed_products";

    /* ---------------------------
       SAVE: Add product to storage
    ---------------------------- */
    function saveRecentlyViewed(productHandle) {
        let products = JSON.parse(localStorage.getItem(recentProductsKey)) || [];
        products = products.filter(p => p !== productHandle);
        products.unshift(productHandle);
        localStorage.setItem(recentProductsKey, JSON.stringify(products));
    }

    /* ---------------------------
       RUN on product page
    ---------------------------- */
    if (document.body.classList.contains("template-product")) {
        const productHandle = window.location.pathname.split("/products/")[1]?.split("/")[0];
        if (productHandle) saveRecentlyViewed(productHandle);
    }

    /* ---------------------------
       RENDER BLOCK
    ---------------------------- */
    const container = document.querySelector(".recently-viewed-carousel");
    if (!container) return;

    const productsHandles = JSON.parse(localStorage.getItem(recentProductsKey)) || [];
    if (productsHandles.length === 0) {
        container.closest(".recently-viewed-section")?.remove();
        return;
    }

    /* ---------------------------
       Ensure jQuery is available
    ---------------------------- */
    function ensureJquery(callback) {
        if (window.jQuery) {
            callback(window.jQuery);
            return;
        }
        const script = document.createElement("script");
        script.src = "https://ajax.googleapis.com/ajax/libs/jquery/3.6.0/jquery.min.js";
        script.onload = () => callback(window.jQuery);
        document.head.appendChild(script);
    }

    /* ---------------------------
       Fetch product + build card
    ---------------------------- */
    function createProductCard(product) {

        const localCountry = Shopify.locale + "-" + Shopify.country;

        const price = (product.price / 100).toLocaleString(localCountry, {
            style: "currency",
            currency: Shopify.currency.active,
            currencyDisplay: "symbol"
        });

        const comparePrice = product.compare_at_price > product.price
            ? (product.compare_at_price / 100).toLocaleString(localCountry, {
                style: "currency",
                currency: Shopify.currency.active,
                currencyDisplay: "symbol"
            })
            : "";

        const img = product.featured_image.replace(
            "//cdn.shopify.com/s/files/1/0742/7938/7333",
            `${window.origin}/cdn/shop`
        );

        const card = document.createElement("div");
        card.className = "product-card";

        card.innerHTML = `
            <div class="product-card--inner">
                <a href="/products/${product.handle}">
                <img src="${img}" alt="${product.title}">
                </a>

                <div class="product-card--content">
                    <a href="/products/${product.handle}" class="product-card-title">
                        ${product.title}
                    </a>

                    <div class="product-card-price">
                        ${price}
                    </div>
                </div>
            </div>
        `;

        // <div class="product-card-price">
        //                 ${price}
        //                 ${comparePrice ? `<span class="compare-price">${comparePrice}</span>` : ""}
        //             </div>

        return card;
    }

    /* ---------------------------
       Insert all products
    ---------------------------- */
    Promise.all(
        productsHandles.map(handle =>
            fetch(`/products/${handle}.js`)
                .then(r => r.ok ? r.json() : null)
        )
    ).then(products => {

        products.filter(Boolean).forEach(product => {
            const url = window.location.href;
            const handle = url.split("/products/")[1].split("/")[0];

            console.log(handle)
            if(product.handle == handle) return;
            const card = createProductCard(product);
            container.appendChild(card);
        });

        initializeCarousel();
    });

    /* ---------------------------
       Init Slick
    ---------------------------- */
    function initializeCarousel() {
        ensureJquery(($) => {

            // Load Slick JS if missing
            if (typeof $.fn.slick === "undefined") {
                const slickScript = document.createElement("script");
                slickScript.src = "https://cdn.jsdelivr.net/npm/slick-carousel@1.8.1/slick/slick.min.js";
                slickScript.onload = startSlick;
                document.head.appendChild(slickScript);
            } else {
                startSlick();
            }

            function startSlick() {
                $('.recently-viewed-carousel').slick({
                    slidesToShow: 4.7,
                    slidesToScroll: 1,
                    infinite: false,
                    arrows: false,
                    dots: false,
                    responsive: [
                        { breakpoint: 1440, settings: { slidesToShow: 3.7 }},
                        { breakpoint: 989, settings: { slidesToShow: 2.5 }},
                        { breakpoint: 749,  settings: { slidesToShow: 1.6 }},
                        { breakpoint: 480,  settings: { slidesToShow: 1.3 }}
                    ]
                });
            }
        });
    }
}

function initCollectionFilterTrigger(){
    document.addEventListener("click", function(e){
        const trigger = e.target.closest(".custom-filter-button");
        if(!trigger) return;

        trigger.classList.toggle("active");
        if(window.innerWidth >= 750) {
            document.querySelector(".main-collection-product-grid .facets-vertical").classList.toggle("filter-open");
        } else {
            document.querySelector(".main-collection-product-grid #main-collection-filters menu-drawer summary").click();
        }
    });
}

function initCustomSpecialProgressBar() {
    const wrapper = document.querySelector(".special-progress-wrapper");
    if (!wrapper) return;

    const headerSpan = wrapper.querySelector(".special-discount-header h3 span");

    // PRODUCT PAGE PROGRESS BAR (optional)
    let productProgressBar = null;
    if (document.body.classList.contains("template-product")) {
        productProgressBar = document.querySelector(
            "product-info .product__info-wrapper .product__info-container .free-shipping-progress"
        );
    }

    fetch('/cart.js')
        .then(res => res.json())
        .then(cart => {
            const cartQty = cart.item_count;

            /* -------------------------------
               HANDLE SPECIAL STEPS PROGRESS BAR
            -------------------------------- */
            const steps = wrapper.querySelectorAll(".step");
            let prevThreshold = 0;
            let latestCompletedLabel = null;

            steps.forEach((step, index) => {
                const threshold = parseInt(step.dataset.productCount);
                const fill = step.querySelector(".step-fill");
                const label = step.querySelector("span").innerText.trim();
                
                let fillPercent = 0;

                // fully complete
                if (cartQty >= threshold) {
                    fillPercent = 100;
                    latestCompletedLabel = label;
                }
                // not started
                else if (cartQty < prevThreshold) {
                    fillPercent = 0;
                }
                // partial progress
                else {
                    const stepRange = threshold - prevThreshold;
                    const progress = cartQty - prevThreshold;
                    fillPercent = Math.max(0, Math.min(100, (progress / stepRange) * 100));
                }

                fill.style.width = fillPercent + "%";
                prevThreshold = threshold;
            });

            if (headerSpan && latestCompletedLabel) {
                headerSpan.textContent = latestCompletedLabel;
            }

            /* ----------------------------------------
               HANDLE PRODUCT PAGE PROGRESS BAR (NEW)
            ----------------------------------------- */
            if (productProgressBar) {
                const productThreshold = parseInt(productProgressBar.dataset.thresholdCount);

                const productSpan = productProgressBar.querySelector("p span");
                const productFill = productProgressBar.querySelector(".progress-bar");

                // Update text: how many more to go
                if (cartQty >= productThreshold) {
                    productProgressBar.querySelector("p").textContent = "Congratulations, you've unlocked 12% off on your entire order + free shipping.";
                } else {
                    if (productSpan) {
                        productSpan.textContent = productThreshold - cartQty;
                    } else {
                        productProgressBar.querySelector("p").innerHTML = `Add <span>${productThreshold - cartQty}</span> more items to get up to 12% off + free shipping over $35!`;
                    }
                }

                // Update progress width
                if (productFill) {
                    let percent = (cartQty / productThreshold) * 100;
                    percent = Math.max(0, Math.min(100, percent)); // keep between 0–100
                    productFill.style.width = percent + "%";
                }
            }

        });
}

function observeCartDrawerUpdates() {
    var cartDrawer = document.querySelector("#occ3-drawer") 
                      || document.querySelector(".CartDrawer") 
                      || document.querySelector(".cart-drawer")
                      || document.querySelector("cart-drawer");
                      
    if (!cartDrawer) return;

    const observer = new MutationObserver(() => {
        initCustomSpecialProgressBar();
        setTimeout(function(){
            addCouponDivInCart();
        }, 500);
    });

    observer.observe(cartDrawer, {
        childList: true,
        subtree: true
    });
}

function addCouponDivInCart() {
    var couponDiv = document.createElement("div");
    couponDiv.classList.add("cart_coupon_text_wrapper");

    var additionalDiv = document.createElement("div");

    fetch('/cart.js')
        .then(response => response.json())
        .then(cart => {
            var cartTotal = cart.total_price / 100; // convert cents to dollars
            var requiredAmount = 70;
            var remaining = requiredAmount - cartTotal;

            if (cartTotal >= requiredAmount) {
                additionalDiv.textContent = 
                    "Congratulations, You will receive a $20 coupon for your next purchase.";
            } else {
                additionalDiv.textContent = 
                    "Spend $" + remaining.toFixed(2) + " more to get a $20 coupon for your next purchase (first-time customers only).";
            }
        });

    couponDiv.appendChild(additionalDiv);

    if (!document.querySelector("#occ3-drawer .cart_coupon_text_wrapper")) {
        if (document.querySelector("#occ3-drawer .spurit-occ3__upsell")) {
            document.querySelector("#occ3-drawer .spurit-occ3__upsell").before(couponDiv);
        } else if (document.querySelector("#occ3-drawer .spurit-occ3__product-cards")) {
            document.querySelector("#occ3-drawer .spurit-occ3__product-cards").append(couponDiv);
        }
    }
}